"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _emailValidation = require("../global/utils/emailValidation");

var _phoneValidation = require("../global/utils/phoneValidation");

var _paymentHelpers = require("../payment/paymentHelpers");

var _genericValidation = require("../global/utils/genericValidation");

var _ReceiptButtonsModule = _interopRequireDefault(require("./ReceiptButtons.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function inputIsValid(type, value) {
  switch (type) {
    case _paymentHelpers.receiptTypes.email:
      return (0, _emailValidation.emailIsValidFormat)(value);

    case _paymentHelpers.receiptTypes.textMessage:
      return (0, _phoneValidation.phoneIsValidFormat)(value);

    case _paymentHelpers.receiptTypes.none:
      return true;

    default:
      return false;
  }
}

var ReceiptButtons = function ReceiptButtons(props) {
  var _props$email = props.email,
      email = _props$email === void 0 ? '' : _props$email,
      _props$phone = props.phone,
      phone = _props$phone === void 0 ? '' : _props$phone,
      _props$cardType = props.cardType,
      cardType = _props$cardType === void 0 ? '' : _props$cardType,
      _props$lastFourDigits = props.lastFourDigits,
      lastFourDigits = _props$lastFourDigits === void 0 ? '' : _props$lastFourDigits,
      _props$defaultSelecte = props.defaultSelected,
      defaultSelected = _props$defaultSelecte === void 0 ? _paymentHelpers.receiptTypes.textMessage : _props$defaultSelecte,
      callback = props.callback,
      gaEventHandlers = props.gaEventHandlers;

  var _useState = (0, _react.useState)(defaultSelected),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = (0, _react.useState)(setInputByReceiptType(defaultSelected)),
      _useState4 = _slicedToArray(_useState3, 2),
      input = _useState4[0],
      setInput = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = _slicedToArray(_useState5, 2),
      isValidInput = _useState6[0],
      setIsValidInput = _useState6[1];

  function setInputByReceiptType(receiptType) {
    switch (receiptType) {
      case _paymentHelpers.receiptTypes.email:
        return email;

      case _paymentHelpers.receiptTypes.textMessage:
        return phone;

      case _paymentHelpers.receiptTypes.none:
        return '';

      default:
        return '';
    }
  }

  var handleClick = function handleClick(receiptType) {
    setSelected(receiptType);
    var value = setInputByReceiptType(receiptType);
    setInput(value);
    if ((0, _genericValidation.isFunction)(gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.click)) gaEventHandlers === null || gaEventHandlers === void 0 ? void 0 : gaEventHandlers.click(receiptType);
  };

  var handleSubmit = function handleSubmit() {
    // Prevent user from clicking button again
    setIsValidInput(false);
    var data = {
      type: selected,
      value: input
    }; // Send receipt info to parent component

    callback(data);
  };

  var setInputValue = function setInputValue(val, type) {
    if (type === _paymentHelpers.receiptTypes.textMessage) {
      setInput("+1".concat((0, _phoneValidation.getPhoneDigitsOnly)(val)));
    } else {
      setInput(val);
    }
  };

  (0, _react.useEffect)(function () {
    var valid = inputIsValid(selected, input);
    setIsValidInput(valid);
  }, [selected, input]);
  return /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement("hr", null), cardType && lastFourDigits && /*#__PURE__*/_react.default.createElement("p", {
    className: _ReceiptButtonsModule.default.prompt
  }, "Your ", /*#__PURE__*/_react.default.createElement("strong", null, cardType), " card ending in", ' ', /*#__PURE__*/_react.default.createElement("strong", null, lastFourDigits), " has been saved successfully"), /*#__PURE__*/_react.default.createElement("p", {
    className: _ReceiptButtonsModule.default.prompt
  }, "I'd like my receipt via"), /*#__PURE__*/_react.default.createElement("div", {
    className: _ReceiptButtonsModule.default.btnContainer
  }, /*#__PURE__*/_react.default.createElement("button", {
    "data-messagedots": "true" // see note in.css file if confused
    ,
    className: selected === _paymentHelpers.receiptTypes.textMessage ? [_ReceiptButtonsModule.default.btn, _ReceiptButtonsModule.default.selected].join(' ') : _ReceiptButtonsModule.default.btn,
    onClick: function onClick() {
      return handleClick(_paymentHelpers.receiptTypes.textMessage);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: 'comment-alt'
  }), /*#__PURE__*/_react.default.createElement("span", null, "Text Msg")), /*#__PURE__*/_react.default.createElement("button", {
    className: selected === _paymentHelpers.receiptTypes.email ? [_ReceiptButtonsModule.default.btn, _ReceiptButtonsModule.default.selected].join(' ') : _ReceiptButtonsModule.default.btn,
    onClick: function onClick() {
      return handleClick(_paymentHelpers.receiptTypes.email);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: 'envelope'
  }), /*#__PURE__*/_react.default.createElement("span", null, "Email")), /*#__PURE__*/_react.default.createElement("button", {
    className: selected === _paymentHelpers.receiptTypes.none ? [_ReceiptButtonsModule.default.btn, _ReceiptButtonsModule.default.selected].join(' ') : _ReceiptButtonsModule.default.btn,
    onClick: function onClick() {
      return handleClick(_paymentHelpers.receiptTypes.none);
    }
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: 'ban'
  }), /*#__PURE__*/_react.default.createElement("span", null, "No Receipt"))), /*#__PURE__*/_react.default.createElement("div", {
    className: _ReceiptButtonsModule.default.miniForm,
    style: selected === _paymentHelpers.receiptTypes.none ? {
      justifyContent: 'flex-end'
    } : {}
  }, selected === _paymentHelpers.receiptTypes.none ? null : /*#__PURE__*/_react.default.createElement("label", {
    "aria-label": "send receipt to"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "email",
    value: input,
    onChange: function onChange(e) {
      return setInputValue(e.target.value, selected);
    },
    className: _ReceiptButtonsModule.default.input,
    placeholder: selected === _paymentHelpers.receiptTypes.email ? 'email@address.com' : selected === _paymentHelpers.receiptTypes.textMessage ? '(xxx) xxx-xxxx' : ''
  })), /*#__PURE__*/_react.default.createElement("button", {
    className: _ReceiptButtonsModule.default.send,
    disabled: !isValidInput,
    onClick: handleSubmit
  }, selected === _paymentHelpers.receiptTypes.none ? 'Done' : 'Send')));
};

var _default = ReceiptButtons;
exports.default = _default;